module.exports = __webpack_public_path__ + "static/media/receive-detail-2.78f077b2.jpg";